import Vue from 'vue'
import VueRouter from 'vue-router'
//import Game from '../views/Game.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Intro',
    component: () => import(/* webpackChunkName: "about" */ '../views/Intro.vue')
   
  },
  
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/credits',
    name: 'Credits',
    component: () => import(/* webpackChunkName: "credits" */ '../views/Credits.vue')
  },
  {
    path: '/depthMap',
    name: 'DepthMap',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dive" */ '../components/DepthMap.vue')
  },
  {
    path: '/dive',
    name: 'Dive',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "dive" */ '../views/UnderwaterSHIP.vue')
  },
  {
    path: '/ocean',
    name: 'Ocean',
    component: () => import('../views/Ocean.vue')
  },
  
  
  {
    path: '/help',
    name: 'Help',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "help" */ '../views/HelpText.vue')
  },
 
  {
    path: '/documents',
    name: 'Documents',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "todo" */ '../views/Documents.vue')
  },
  {
    path: '/dropzone',
    name: 'Dropzone',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "todo" */ '../views/DropZone.vue')
  },
  {
    path: '/wreckdata',
    name: 'WreckData',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "todo" */ '../views/WreckData.vue')
  },
  
  
  {
    path: '/ship',
    name: 'Ship',
    component: () => import(/* webpackChunkName: "todo" */ '../views/Ship.vue')
  },
  {
    path: '/underwater',
    name: 'Underwater',
   
    component: () => import(/* webpackChunkName: "underwater" */ '../views/Underwater.vue')
  },
  {
    path: '/underwaterShip',
    name: 'UnderwaterShip',
   
    component: () => import(/* webpackChunkName: "underwaterShip" */ '../views/UnderwaterSHIP.vue')
  },
  {
    path: '/exhibition',
    name: 'Exhibition',
   
    component: () => import(/* webpackChunkName: "Exhibition" */ '../views/Exhibition.vue')
  },
  {
    path: '/publicexhibition',
    name: 'PublicExhibition',
   
    component: () => import(/* webpackChunkName: "PublicExhibition" */ '../views/PublicExhibition.vue')
  },
  {
    path: '/exhibitPlan',
    name: 'ExhibitPlan',
   
    component: () => import(/* webpackChunkName: "ExhibitionPlanning" */ '../views/ExhibitPlanning.vue')
  },
  {
    path: '/game',
    name: 'Game2',
   
    component: () => import(/* webpackChunkName: "game" */ '../views/Game.vue')
  },
  {
    path: '/intro',
    name: 'Intro',
   
    component: () => import(/* webpackChunkName: "game" */ '../views/Intro.vue')
  },
  {
    path: '/planning',
    name: 'Planning',
   
    component: () => import(/* webpackChunkName: "planning" */ '../views/Planning.vue')
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
